import { render, staticRenderFns } from "./HeadBtn.vue?vue&type=template&id=61284d0a&scoped=true&"
import script from "./HeadBtn.vue?vue&type=script&lang=js&"
export * from "./HeadBtn.vue?vue&type=script&lang=js&"
import style0 from "./HeadBtn.vue?vue&type=style&index=0&id=61284d0a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61284d0a",
  null
  
)

export default component.exports